
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/faq",
      function () {
        return require("private-next-pages/faq.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/faq"])
      });
    }
  